// Global JavaScript utilities

// Debounce function
function debounce(fn, wait) {
  let t
  return (...args) => {
    clearTimeout(t)
    t = setTimeout(() => fn.apply(this, args), wait)
  }
}

// Fetch cart
async function fetchCart() {
  const response = await fetch(window.routes.cart_url + ".js")
  return response.json()
}

// Update cart count
function updateCartCount(count) {
  const countElements = document.querySelectorAll(".header__cart-count")
  countElements.forEach((el) => (el.textContent = count))
}

// Add to cart
async function addToCart(id, quantity = 1) {
  const response = await fetch(window.routes.cart_add_url + ".js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      items: [{ id, quantity }],
    }),
  })

  const cart = await response.json()
  updateCartCount(cart.item_count)
  return cart
}

// Format money
function formatMoney(cents, format = "${{amount}}") {
  const amount = (cents / 100).toFixed(2)
  return format.replace("{{amount}}", amount)
}

// Initialize when DOM is ready
document.addEventListener("DOMContentLoaded", () => {
  // Add any global initialization here
})
